if (!customElements.get('video-showcase')) {
    class VideoShowcase extends HTMLElement {
        connectedCallback() {
            this.videos = Array.from(this.querySelectorAll('video'));
            if (!this.videos.length) return;

            this.videos.forEach((video) => {
                // iOS / Safari need the muted + playsinline properties set in JS as well as in markup.
                video.muted = true;
                video.defaultMuted = true;
                video.playsInline = true;
                video.setAttribute('muted', '');
                video.setAttribute('playsinline', '');
                video.setAttribute('webkit-playsinline', '');
            });

            this.onVisibilityChange = () => {
                if (!document.hidden) this.playVisibleVideos();
            };
            // Low Power Mode / data saver can block autoplay until the first user gesture.
            this.onFirstInteraction = () => this.playVisibleVideos();

            if ('IntersectionObserver' in window) {
                this.observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting) {
                                this.play(entry.target);
                            } else {
                                entry.target.pause();
                            }
                        });
                    },
                    { threshold: 0.25 }
                );
                this.videos.forEach((video) => this.observer.observe(video));
            } else {
                this.videos.forEach((video) => this.play(video));
            }

            document.addEventListener('visibilitychange', this.onVisibilityChange);
            ['touchstart', 'click', 'scroll'].forEach((type) =>
                window.addEventListener(type, this.onFirstInteraction, { once: true, passive: true })
            );
        }

        disconnectedCallback() {
            if (this.observer) this.observer.disconnect();
            document.removeEventListener('visibilitychange', this.onVisibilityChange);
            ['touchstart', 'click', 'scroll'].forEach((type) =>
                window.removeEventListener(type, this.onFirstInteraction)
            );
        }

        play(video) {
            const promise = video.play();
            if (promise && typeof promise.catch === 'function') promise.catch(() => { });
        }

        playVisibleVideos() {
            this.videos.forEach((video) => {
                const rect = video.getBoundingClientRect();
                const isVisible =
                    rect.bottom > 0 &&
                    rect.right > 0 &&
                    rect.top < window.innerHeight &&
                    rect.left < window.innerWidth;
                if (isVisible && video.paused) this.play(video);
            });
        }
    }

    customElements.define('video-showcase', VideoShowcase);
}